import React, { useState } from "react";
import { IHeaderParams } from "ag-grid-community";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

/**
 * 디자인 모드용 그리드 헤더 — hover 시 X 아이콘이 떠서 컬럼을 제거할 수 있다.
 * 컬럼 이동(드래그)/리사이즈는 ag-grid가 헤더 셀 레벨에서 처리하므로 그대로 동작한다.
 * (SnGrid에 onDesignColumnRemove prop을 넘긴 경우에만 적용됨)
 */
interface DesignRemovableHeaderProps extends IHeaderParams {
  onRemove?: (cdColumn: string) => void;
}

const DesignRemovableHeader: React.FC<DesignRemovableHeaderProps> = (props) => {
  const [hover, setHover] = useState(false);
  const colId = props.column.getColId();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        position: "relative",
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={(e) => {
        if (props.enableSorting) props.progressSort(e.shiftKey);
      }}
    >
      <span className="ag-header-cell-text">{props.displayName}</span>
      <span
        style={{
          position: "absolute",
          top: "50%",
          right: 2,
          transform: "translateY(-50%)",
          cursor: "pointer",
          zIndex: 10,
          background: "white",
          borderRadius: "50%",
          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
          display: hover ? "flex" : "none",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={(e) => {
          e.stopPropagation();
          props.onRemove?.(colId);
        }}
      >
        <HighlightOffIcon sx={{ fontSize: 15 }} color="error" />
      </span>
    </div>
  );
};

export default DesignRemovableHeader;
